import { type PolymorphicComponent } from '@mui/base'
import { clsx } from 'clsx'

import { IconArrowRight } from '@redteclab/icons'

import { Button, type ButtonProps, type ButtonTypeMap } from 'base-ui'

export const ContactPageSectionFlatCta: PolymorphicComponent<ButtonTypeMap> = (
  props: ButtonProps,
) => {
  const { children, className, onClick, startIcon, ...other } = props

  return (
    <Button
      className={clsx(
        'w-full justify-between gap-1 rounded-m bg-light-brand-medium px-4 py-6 active:bg-light-pressed-brand-medium',
        className,
      )}
      endIcon={<IconArrowRight />}
      onClick={onClick}
      startIcon={startIcon}
      variant="text"
      {...other}
    >
      <span className="grow whitespace-normal text-start">{children}</span>
    </Button>
  )
}
